import axios from 'axios';

export const getStrategistOverview = (timePeriod) => {
  return axios.get(`/api/chatbot/strategistOverview/${timePeriod}`);
};

export const getChatHistory = (timePeriod) => {
  return axios.get(`/api/chatbot/chatHistory/${timePeriod}`);
};

export const getQuestionAnswer = (questionId, organizationName) => {
  return axios.get('/api/chatbot/questionAnswer', {
    params: { questionId, organizationName }
  });
};
